// import { hasScope } from "authorization";
import { hasScope } from "authorization";
import CustomHorizontalTabs from "components/molecules/CustomHorizontalTabs";
import { useGetMyProfileUserInfoQuery } from "graphqlBase/user/__generated__/getMyProfileUserInfo";
import { useGetPendingUserRequestsQuery } from "graphqlBase/userManagement/user/__generated__/getPendingUserRequests";
import { useGetUserInfo } from "lib/userInfo";
import React from "react";
import { atom, useSetRecoilState } from "recoil";
import translations from "translations";

export const isPlatformOperatorAtom = atom<boolean>({
  key: "isPlatformOperator",
  default: false,
});

const Navigation: React.FC = () => {
  const { data } = useGetPendingUserRequestsQuery({
    fetchPolicy: "cache-and-network",
    variables: {
      where: { approvalStatus: { eq: "PENDING" } },
    },
  });

  const userInfo = useGetUserInfo();
  const { data: userInfos } = useGetMyProfileUserInfoQuery({ variables: { id: userInfo?.id ?? "" } });
  const setIsPlatformOperator = useSetRecoilState(isPlatformOperatorAtom);
  const userIsPlatformOperator = userInfos?.user?.userBridgeRoles.map((e) => e.role.name).includes("Platform Operator");
  setIsPlatformOperator(userIsPlatformOperator ?? false);
  const totalCount = data?.users?.totalCount ?? 0;
  const renderElementsStartPre = [
    {
      label: translations.pages.userManagement.tabs.userAndRolesAssignment,
      To: "/userManagement",
    },

    {
      label: translations.pages.userManagement.tabs.pendingUserRequests,

      To: "/userManagement/pendingUserRequests",
      totalCount: totalCount,
      showTotlaCount: true,
    },
    {
      label: userIsPlatformOperator ? translations.entities.tenant.plural : translations.entities.tenant.myTenants,
      To: userIsPlatformOperator ? "/userManagement/tenantOverview" : "/userManagement/Mytenant",
    },
  ];

  const renderElementsStart = hasScope("ApproveOrBlockUsers.Create")
    ? renderElementsStartPre
    : [
        {
          label: translations.pages.userManagement.tabs.userAndRolesAssignment,
          To: "/userManagement",
        },
        {
          label: userIsPlatformOperator ? translations.entities.tenant.plural : translations.entities.tenant.myTenants,
          To: userIsPlatformOperator ? "/userManagement/tenantOverview" : "/userManagement/myTenant",
        },
      ];

  return <CustomHorizontalTabs renderElementsStart={renderElementsStart} />;
};

export default Navigation;
